




















































import Vue from 'vue';
import RideeEvent from '@/event/event';
import { formatIntoComponents } from '@/utils/date_time';

export default Vue.extend({
  props: {
    event: {
      type: RideeEvent,
      required: true,
    },
  },
  data() {
    return {
      relative: undefined as string | undefined,
      weekday: undefined as string | undefined,
      date: undefined as string | undefined,
      time: undefined as string | undefined,
    };
  },
  computed: {
    location(): string | null {
      const location = this.event.location;
      if (!location) return null;
      return location.description;
    },
  },
  mounted() {
    const c = formatIntoComponents(this.event.startDateTime, true);
    this.relative = c.relative;
    this.weekday = c.weekday;
    this.date = c.date;
    this.time = c.time == '00:00' ? '' : c.time;
  },
});
